
import { observable, action } from 'mobx';
import { plainToClassFromExist } from 'class-transformer';

import ArticleService from '../../service/ArticleService/ArticleService';
/**
 * 获取文章列表
 *
 ***/
export class ArticleListModel {
    @observable public pageCount: number;
    @observable public pageNo: number;
    @observable public pageSize: number;
    @observable public results: Array<{ browseSum: number, commentSum: number, favourSum: number, id: number, shareSum: number, status: number, surfacePlot: string, title: string, updateTime: string, rejectDesc: string, releaseTime: string }>;
    @observable public totalCount: number;

    @action public init(pageNo: number, pageSize: number, config: any) {
        return ArticleService.getArticleList(pageNo, pageSize, config).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// 删除文章
export class ArticleDeleteModel {
    @action public init(ID: number, config: any) {
        return ArticleService.deleteArticle(ID, config).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// 立即发布文章
export class ArticleImmediatePub {
    @action public init(ID: number, config: any) {
        return ArticleService.immediatelyPubArticle(ID, config).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// 文章详情

export class ArticleDetail {
    @observable public articleId: number;
    @observable public content: string;
    @observable public createTime: string;
    @observable public picArray: Array<{ imageUrl: string, type: number, videoId: string }>;
    @observable public surfacePlot: string;
    @observable public title: string;
    @observable public updateTime: string;
    @observable public videoArray: Array<{ imageUrl: string, type: number, videoId: string }>;
    @observable public status: number;
    @observable public releaseTime: string;
    @observable public nickname: string;
    @observable public avatar: string;
    @action public init(ID, config) {
        return ArticleService.getDetail(ID, config).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// 发布文章&&修改文章

export class ArticleCreateUpdate {
    @action public init(param, config) {
        return ArticleService.createOrUpdateArticle(param, config).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}
// 保存草稿&&修改草稿

export class ArticleSaveDraft {
    @action public init(param, config) {
        console.log(param,config);
        return ArticleService.saveDraft(param, config).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// 获取文章详情手机预览二维码
export class ArticlePreviewQrcode {
    @action public get(productId, config) {
        return ArticleService.getPhonePreviewQrcode(productId, config).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}
